import { useTranslation } from "react-i18next";

import { useDipLabels } from "~/features/dataImportProjects/hooks/useDipLabels";

const STEPS = [
  { n: 1, key: "steps.import", anchor: "pipeline-import" },
  { n: 2, key: "steps.compose", anchor: "pipeline-compose" },
] as const;

export function DipPipelineStepper() {
  const { t } = useTranslation();
  const labels = useDipLabels();
  return (
    <nav className="flex overflow-hidden rounded-[var(--radius-md)] border border-border-default">
      {STEPS.map((step) => (
        <a
          key={step.key}
          href={`#${step.anchor}`}
          className="flex items-center gap-2 border-r border-border-default px-3 py-2 text-fg-3 last:border-r-0 hover:bg-bg-subtle"
        >
          <span className="text-12-bold text-fg-3">
            {t("feature.dataImportProjects.v2.pipeline.step", { n: step.n })}
          </span>
          <strong className="text-14-bold text-fg-1">{labels[step.key] ?? step.key}</strong>
        </a>
      ))}
    </nav>
  );
}
